<template>
  <div class="sign">
    <div class="sign_head">领用出库</div>
    <template v-if="!isCompleted">


      <div class="sign_panel sign_info">
        <div class="sign_item">
          <div class="sign_item-label">
            <img class="sign_icon" src="../../assets/images/sign/icon-lybt.png" alt="">领用标题：
          </div>
          <div class="sign_info-val">
            {{data.outTitle}}
          </div>
        </div>

        <div class="sign_item">
          <div class="sign_item-label">
            <img class="sign_icon" src="../../assets/images/sign/icon-lydh.png" alt="">领用单号：
          </div>
          <div class="sign_info-val">
            {{data.outCode}}
          </div>
        </div>

        <div class="sign_item">
          <div class="sign_item-label">
            <img class="sign_icon" src="../../assets/images/sign/icon-lyrs.png" alt="">领用人：
          </div>
          <div class="sign_info-val">
            {{data.userName}}
          </div>
        </div>

      </div>

      <div class="sign_panel sign_info">

        <div class="sign_item">
          <div class="sign_item-label">
            <img class="sign_icon" src="../../assets/images/sign/icon-pmmc.png" alt="">品目名称：
          </div>
          <div class="sign_info-val">
            {{data.itemName}}
          </div>
        </div>
        <div class="sign_item">
          <div class="sign_item-label">
            <img class="sign_icon" src="../../assets/images/sign/icon-kcsl.png" alt="">库存数量：
          </div>
          <div class="sign_info-val">
            {{data.invNo}}
          </div>
        </div>

        <div class="sign_item">
          <div class="sign_item-label">
            <img class="sign_icon" src="../../assets/images/sign/icon-lysl.png" alt="">领取数量：
          </div>
          <div class="sign_info-val">
            {{data.no}}
          </div>
        </div>

      </div>


      <div style="margin-bottom: 1.2rem" class="sign_panel">
        <div class="sign_panel-head">
          <div>
            <img class="sign_icon" src="../../assets/images/sign/icon-qm.png" alt="">
            签名
          </div>
        </div>
        <div class="sign_panel-body">
          <div class="sm">
            <div>
              <img class="sign_icon" src="../../assets/images/sign/icon-sm.png" alt="">
            </div>

            说明：领用出库后，商品由领用人负责，如出现丢失损坏，会按照适当成本赔偿。签字代表同意本说明。
          </div>
          <div class="qm" @click="gotoSign">
            <template v-if="!url">
              <img src="../../assets/images/sign/bg-qm.png" class="placeholeder" alt="">
              <span>点击进入签名</span>
            </template>
            <img :src="url" v-else alt="" class="signimg">
          </div>

        </div>
      </div>

      <div class="sign_bottom">
        <button type="button" @click="gotoSign">重新签名</button>
        <button type="button" class="confirm" @click="save">保存</button>
      </div>
    </template>
    <div class="sign_completed" v-else>
      <img src="../../assets/images/sign/completed.png" alt="">
      <p>完成</p>
    </div>
  </div>
</template>
<script>
  import './flexible'
  import axios from "axios";
  import Toast from "./toast.js";

  export default {
    name: 'ClazzList',
    data() {
      return {
        data: {},
        isCompleted: false,
        url: null,
        loading: false
      }
    },

    beforeRouteEnter(to, from, next) {
      next(vm => {
        if (from.name === 'Sign') {
          vm.url = vm.$route.params.url
        } else {
          let outId = to.query.outId
          vm.isCompleted = false
          if (from.name === null) {
            axios.get(`${process.env.SIGN_API_ROOT}/ims/storage/coach/sign/take/info/${outId}`).then((res) => {
              if (res.data.errCode === '00') {
                vm.data = res.data.data
              } else {
                Toast(res.data.errMsg)
              }
            }, err => {
              Toast('出错了')
            })
          }
        }
      })

    },
    methods: {
      save() {
        if (!this.url) {
          Toast('请签名')
          return;
        }
        if (this.loading) return;
        this.loading = true
        axios.post(`${process.env.SIGN_API_ROOT}/ims/storage-output/sign/add`, {
          businessId: this.data.outId,
          signType: 0,
          signUrl: this.url
        }).then((res) => {
          if (res.data.errCode === '00') {
            this.isCompleted = true
          } else {
            Toast(res.data.errMsg)
          }
          this.loading = false
        }, err => {
          this.loading = false
          Toast('出错了')
        })
      },
      gotoSign() {
        this.$router.push({name: 'Sign', params: {url: this.url}})
      }
    }
  }
</script>
<style scoped>
  .sign {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #f8f8f8;
    overflow: auto;
    display: flex;
    flex-direction: column;
  }

  .sign_completed {
    width: 7.3rem;
    height: 7.3rem;
    border-radius: 5px;
    text-align: center;
    margin: auto;
    background: #ffffff;
    color: #333333;
    font-size: .42rem;
  }

  .sign_completed img {
    width: 3.68rem;
    height: 2.35rem;
    margin-top: 1.3rem;
    margin-bottom: .9rem;
  }

  .sign_completed .desc {
    font-size: .37rem;
    color: #666666;
    margin-top: .3rem;
  }

  .sign_head {
    height: 1rem;
    line-height: 1rem;
    background: #ffffff;
    text-align: center;
    font-size: 0.4rem;
    border-bottom: .013rem solid #c7c7c7;
    flex: 0;
  }

  .sign_panel {
    margin: .26rem auto;
    padding: .13rem .4rem;
    width: 92%;
    border-radius: .125rem;
    background: #ffffff;
    box-sizing: border-box;
    color: #666666;
    font-size: .34rem;
  }

  .sign_info {
    margin: .26rem auto .4rem;
  }

  .sign_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .sign_info .sign_item {
    height: .88rem;
  }

  .sign_info .sign_item-label {
    color: #666666
  }

  .sign_icon {
    width: .32rem;
    margin-top: -.05rem;
    margin-right: .13rem;
  }

  .sign_info-val {
    font-size: 0.4rem;
    color: #333333;
  }

  .qm {
    position: relative;
    width: 100%;
    height: 4.72rem;
    line-height: 4.72rem;
    color: #0D80FE;
    font-size: .42rem;
    margin-bottom: .26rem;
    text-align: center;
  }

  .qm img.placeholeder {
    width: 100%;
    height: 100%;
  }

  .qm img.signimg {
    height: 100%;
  }

  .qm span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .sm {
    font-size: .28rem;
    color: #FD1919;
    display: flex;
    margin: .1rem 0;
  }

  .sm .sign_icon {
    width: .32rem;
    height: .32rem;
  }

  .sign_bottom {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    display: flex;
    height: 1rem;
  }

  .sign_bottom button {
    flex: 1;
    border: none;
    font-size: .37rem;
    background: #ffffff;
    border-top: 1px solid #eeeeee;
  }

  .sign_bottom button.confirm {
    background: #0D80FE;
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// LingYongChuKu.vue?61759b34